import React, { FC } from 'react';

import { SummaryAndPaymentProps } from './models';
import Payment from './Payment';
import Summary from './Summary';

const SummaryAndPayment: FC<SummaryAndPaymentProps> = ({
  cartSummary,
  paymentMethods,
  paymentMethodsLabel,
  paymentMethodsLabelUI,
  paymentDescriptionsWithImage,
  handleCheckout,
}) => (
  <div className="shopping-cart__summary-and-payment">
    <Summary {...cartSummary} handleCheckout={handleCheckout} />
    <Payment
      {...{
        paymentMethods,
        paymentMethodsLabel,
        paymentMethodsLabelUI,
        paymentDescriptionsWithImage,
      }}
    />
  </div>
);

export default SummaryAndPayment;
